import bStrg, { parsedToken } from "../storageHelper";
import { apiAService } from "../apiService";
import urlConfig from "../../../config/domain";
import { appIdKey, jwtToken } from "../../types/genericTypes";

const pToken: jwtToken | null = parsedToken(),
  userID = pToken ? pToken.username : null,
  appInfo: appIdKey = bStrg("appInfo");

export const GenerateLead = async (payload: any) => {
  return await apiAService({
    url: `${urlConfig.merceApiUrl}saveleadinfo`,
    method: "POST",
    authType: "bearer",
    body: payload,
  });
};
